import LabeledStateInput from "components/labeledInput/LabeledStateInput";
import { formikConnect } from "utils/formikConnect";

export default formikConnect(LabeledStateInput);
